import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '*',
    component: () => import('../views/404.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {layout: 'notauth'},
  },
  {
    path: '/about',
    name: 'About',
    meta: {layout: 'notauth'},
    component: () => import('../views/About.vue')
  },
  {
    path: '/productpage/:id',
    name: 'ProductPage',
    meta: {layout: 'notauth'},
    component: () => import('../views/ProductPage.vue')
  },
  {
    path: '/basket',
    name: 'Basket',
    meta: {layout: 'notauth'},
    component: () => import('../views/Basket.vue')
  },
  {
    path: '/favorite',
    name: 'Favorite',
    meta: {layout: 'notauth'},
    component: () => import('../views/Favorite.vue')
  },
  {
    path: '/category/:id',
    name: 'FilterCategory',
    meta: {layout: 'notauth'},
    component: () => import('../views/FilterCategory.vue')
  },
  {
    path: '/blogs',
    name: 'Blogs',
    meta: {layout: 'notauth'},
    component: () => import('../views/Blogs.vue')
  },
  {
    path: '/contractpayment',
    name: 'ContractPayment',
    meta: {layout: 'notauth'},
    component: () => import('../views/ContractPayment.vue')
  },
  {
    path: '/policy',
    name: 'Policy',
    meta: {layout: 'notauth'},
    component: () => import('../views/Policy.vue')
  },
  {
    path: '/blog/:id',
    name: 'Blog',
    meta: {layout: 'notauth'},
    component: () => import('../views/Blog.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: {layout: 'profile', auth: true},
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/neworder',
    name: 'NewOrder',
    meta: {layout: 'neworder', auth: true},
    component: () => import('../views/NewOrder.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next)=> {
    const currentUser = store.getters.USER.length
    const requireAuth = to.matched.some(record => record.meta.auth)
    if (requireAuth && currentUser == 0) {
       next('/')
    } else {
       next()
    }
})

export default router
